import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Main } from '../../components'
import Card from '../../components/Card'
import Reveal from '../Home/components/landing/Reveal'
import { useSupportContent } from '../../config/queries'
import { SUPPORT_SECTIONS } from './sections'
import SupportFaqAccordion from './SupportFaqAccordion'
import SupportPageHeader from './SupportPageHeader'

const SupportHub = () => {
  const { t } = useTranslation()
  const { data, isPending } = useSupportContent()

  const globalFaqs = data?.faqEntries?.filter((entry) => !entry.section) ?? []

  return (
    <Main title={t('support.hub-title')}>
      <SupportPageHeader
        title={t('support.hub-title')}
        description={t('support.hub-description')}
        footer={
          <p className='text-sm text-muted-foreground'>
            {t('support.discord-description')}{' '}
            <a
              href='https://discord.gg/86eUAFz'
              target='_blank'
              rel='noreferrer'
              className='font-medium text-primary hover:text-primary/90'
            >
              {t('support.discord-link')}
            </a>
          </p>
        }
      />

      <div className='grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5 pb-12 mb-8 border-b'>
        {SUPPORT_SECTIONS.map(({ slug, icon: Icon }, index) => (
          <Reveal key={slug} delay={index * 0.06} y={16}>
            <Link to={`/support/${slug}`} className='block h-full'>
              <Card className='flex h-full flex-col items-center justify-center gap-3 p-6 text-center transition-colors hover:border-primary/40'>
                <div className='flex h-12 w-12 items-center justify-center rounded-md bg-primary/10 text-primary'>
                  <Icon className='h-6 w-6' />
                </div>
                <span className='text-base font-medium leading-tight'>
                  {t(`support.sections.${slug}.title`)}
                </span>
              </Card>
            </Link>
          </Reveal>
        ))}
      </div>

      {isPending ? null : <SupportFaqAccordion entries={globalFaqs} />}
    </Main>
  )
}

export default SupportHub
